import React, { Component } from "react";
import { get as apiGet, post as apiPost, put as apiPut } from "aws-amplify/api";
import 'containers/common/Detail.css';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import PropertySaleSheetList from "containers/property/PropertySaleSheetList";
import PropertySaleSheetModal from "containers/property/PropertySaleSheetModal";
import SaleSheetClassificationModal from "containers/salesheet/SaleSheetClassificationModal";
import SaleSheetClassificationList from "containers/salesheet/SaleSheetClassificationList";

import { Form, Row, Col, Card, InputGroup, Tabs, Tab, Button, Alert, Nav, Modal } from "react-bootstrap";


import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import { PacmanLoader } from 'react-spinners';
import Moment from "moment";

const pendingCloneSaleSheetSaves = new Set();

const API = {
    async get(apiName, path, options = {}) {
        const response = await apiGet({
            apiName,
            path,
            options: {
                queryParams: options?.queryStringParameters,
            },
        }).response;
        return response.body.json();
    },
    async post(apiName, path, options = {}) {
        const response = await apiPost({
            apiName,
            path,
            options: {
                body: options?.body,
            },
        }).response;
        return response.body.json();
    },
    async put(apiName, path, options = {}) {
        const response = await apiPut({
            apiName,
            path,
            options: {
                body: options?.body,
            },
        }).response;
        return response.body.json();
    },
};

class SaleSheetDetailClass extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        this.cloneSaveKey = null;

        

        this.state = {
            isLoading: null,
            isDeleting: null,
            modified: false,
            evermodified: false,
            savingNew: false,
            saleSheet: null, 
            propertySaleSheets: [],
            showAlert: false,
            errorMessage: "",
            idList: [],
            previousId: -1,
            nextId: -1,
            propertyidlist: [],

            original_sale_follow_up_date: null,

            showPropertySaleSheetDialog: false,
            classificationOptions: [],
            saleSheetClassificationFilter: null,            
            showSaleSheetClassificationDialog: false,
            saleSheetClassifications: [],

            propertySaleSheetsFilter: null,

            saleStatusOptions: [],
            selectedSaleStatus: null,

            selectedAgent1Contact1: null,
            selectedAgent1Contact2: null,
            selectedAgent2Contact1: null,
            selectedAgent2Contact2: null,

            agent1ContactOptions: [],
            agent2ContactOptions: [],
            agent1MenuIsOpen: false,
            agent2MenuIsOpen: false,
            agent1InterstateFlag: false,
            agent2InterstateFlag: false,
            showAgent1DropDown: false,
            showAgent2DropDown: false,

            showAgent1Contact1DropDown: false,
            showAgent1Contact2DropDown: false,
            showAgent2Contact1DropDown: false,
            showAgent2Contact2DropDown: false,

            agent1Options: [],
            agent2Options: [], 

            agent1SearchString: null,
            agent2SearchString: null,

            property_key: this.props.match.params.propertyid,
            property_id: null,
            sale_sheet_id: null,
            current: null,
            sales_notes: null,
            sale_status_code: null,
            sale_status: null,
            sale_status_date_checked: null, 
            sale_follow_up_date: null,
            entity_id_sale_agent_1: null,
            sale_agent_1: null,
            entity_id_sale_agent_2: null, 
            sale_agent_2: null,
            sale_agent_1_phone: null,
            sale_agent_2_phone: null,
            sale_agent_1_contacts: null,
            sale_agent_2_contacts: null,
            current_questions: null,
            quick_ref: null,
            entity_contact_id_1_sale_agent_1: null,
            contact_1_sale_agent_1: null,
            contact_1_sale_agent_1_phone: null,
            contact_1_sale_agent_1_email: null,
            entity_contact_id_2_sale_agent_1: null,
            contact_2_sale_agent_1: null,
            contact_2_sale_agent_1_phone: null,
            contact_2_sale_agent_1_email: null,
            entity_contact_id_1_sale_agent_2: null,
            contact_1_sale_agent_2: null,
            contact_1_sale_agent_2_phone: null,
            contact_1_sale_agent_2_email: null,
            entity_contact_id_2_sale_agent_2: null,
            contact_2_sale_agent_2: null,
            contact_2_sale_agent_2_phone: null,
            contact_2_sale_agent_2_email: null,
            doc_date_ordered: null,
            doc_date_rec: null,
            doc_notes: null,
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null,
            archived_date: null

        };



       

    }

 

    // async componentWillUnmount() {
    //    // source.cancel();
        
    //     this.setState({ saleSheet: [] });
    //     this.setState({ suburbOptions: [] });
    //     this.setState({ agentOptions: [] });
    //     this.setState({ properties: [] });
       
        
    // }

    componentDidUpdate(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
        }
    }
  
    async createPropertyLinks(){
        var i;
        let propertySaleSheets = [...this.props.location.state.propertySaleSheets]
        for( i = 0; i<propertySaleSheets.length;i++) {
            propertySaleSheets[i].property_id = propertySaleSheets[i].property_id || this.state.property_id || null;
            propertySaleSheets[i].property_key = propertySaleSheets[i].property_key || this.state.property_key || null;
            propertySaleSheets[i].sale_sheet_id = this.state.sale_sheet_id;
            propertySaleSheets[i].new_record = true;
            const result = await this.saveRecord(propertySaleSheets[i], "propertySaleSheets", "property_sale_sheet_id");
            if (result.result) {
                propertySaleSheets[i].property_sale_sheet_id = result.id;
                propertySaleSheets[i].new_record = false;
                
            }
            else {
                this.setState({ errorMessage: result.error_message });
                this.setState({ showAlert: true });
            }
        }
        
        return propertySaleSheets
        
    };

    async createCategoryLinks(){
        var i;
        let saleSheetClassifications = [...this.props.location.state.saleSheetClassifications]
        for( i = 0; i<saleSheetClassifications.length;i++) {
            saleSheetClassifications[i].sale_sheet_id = this.state.sale_sheet_id;
            saleSheetClassifications[i].new_record = true;
            const result = await this.saveRecord(saleSheetClassifications[i], "saleSheetClassifications", "sale_sheet_classification_id");
            if (result.result) {
                saleSheetClassifications[i].sale_sheet_classification_id = result.id;
                saleSheetClassifications[i].new_record = false;
                
            }
            else {
                this.setState({ errorMessage: result.error_message });
                this.setState({ showAlert: true });
            }
        }
        
        return saleSheetClassifications
        
    };

    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   
            if (this.props.location.state){
                if (this.props.location.state.hasOwnProperty("data")){
                    const idList = this.props.location.state.data;
                    var currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));

                    let nextId = null;
                    let previousId = null;
                    
                    if (currentIdIndex+1 < idList.length){
                        nextId = idList[currentIdIndex+1];
                        
                    }
                    if (currentIdIndex >0){
                        previousId = idList[currentIdIndex-1];                            
                    }
                    this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                }
                
                if (this.props.location.state.propertyidlist){
                    this.setState({propertyidlist: this.props.location.state.propertyidlist});
                }
                
            }
            if (this.props.match.params.id === "new") {
                console.log("New sale sheet");
                var options = {  year: 'numeric', month: 'long', day: 'numeric' };
                //Check if used has selected to clone
                if (this.props.location.state){
                    if (this.props.location.state.salesheet){
                        const cloneSaveKey = this.props.location.key || `${this.props.location.pathname}${this.props.location.search}`;
                        if (pendingCloneSaleSheetSaves.has(cloneSaveKey)) {
                            this.setState({ isLoading: false });
                            return;
                        }

                        pendingCloneSaleSheetSaves.add(cloneSaveKey);
                        this.cloneSaveKey = cloneSaveKey;
                        console.log("Clone salesheet found");
                        const clonedPropertyId = this.props.location.state.property_id || this.props.location.search.replace("?propertyid=", "") || null;
                        const saleSheet = this.props.location.state.salesheet;
                        const created_date= new Date;
                        const created_by= this.props.user;
                        const {                            
                            current,
                            sales_notes,
                            sale_status_code,
                            sale_status,
                            sale_status_date_checked,
                            sale_follow_up_date,
                            entity_id_sale_agent_1,
                            sale_agent_1,
                            entity_id_sale_agent_2,
                            sale_agent_2,
                            sale_agent_1_phone,
                            sale_agent_2_phone,
                            sale_agent_1_contacts,
                            sale_agent_2_contacts,
                            current_questions,
                            quick_ref,
                            entity_contact_id_1_sale_agent_1,
                            contact_1_sale_agent_1,
                            contact_1_sale_agent_1_phone,
                            contact_1_sale_agent_1_email,
                            entity_contact_id_2_sale_agent_1,
                            contact_2_sale_agent_1,
                            contact_2_sale_agent_1_phone,
                            contact_2_sale_agent_1_email,
                            entity_contact_id_1_sale_agent_2,
                            contact_1_sale_agent_2,
                            contact_1_sale_agent_2_phone,
                            contact_1_sale_agent_2_email,
                            entity_contact_id_2_sale_agent_2,
                            contact_2_sale_agent_2,
                            contact_2_sale_agent_2_phone,
                            contact_2_sale_agent_2_email,
                            doc_date_ordered,
                            doc_date_rec,
                            doc_notes                            
                            } = saleSheet;
                            
                            this.setState({                                                                
                                current,
                                sales_notes,
                                sale_status_code,
                                sale_status,
                                sale_status_date_checked,
                                sale_follow_up_date : (new Date()).toLocaleDateString('en-AU',options),
                                entity_id_sale_agent_1,
                                sale_agent_1,
                                entity_id_sale_agent_2,
                                sale_agent_2,
                                sale_agent_1_phone,
                                sale_agent_2_phone,
                                sale_agent_1_contacts,
                                sale_agent_2_contacts,
                                current_questions,
                                quick_ref,
                                entity_contact_id_1_sale_agent_1,
                                contact_1_sale_agent_1,
                                contact_1_sale_agent_1_phone,
                                contact_1_sale_agent_1_email,
                                entity_contact_id_2_sale_agent_1,
                                contact_2_sale_agent_1,
                                contact_2_sale_agent_1_phone,
                                contact_2_sale_agent_1_email,
                                entity_contact_id_1_sale_agent_2,
                                contact_1_sale_agent_2,
                                contact_1_sale_agent_2_phone,
                                contact_1_sale_agent_2_email,
                                entity_contact_id_2_sale_agent_2,
                                contact_2_sale_agent_2,
                                contact_2_sale_agent_2_phone,
                                contact_2_sale_agent_2_email,
                                doc_date_ordered,
                                doc_date_rec,
                                doc_notes,
                                property_id: clonedPropertyId,
                                created_date,
                                created_by
                            },async()=>{
                                        try {
                                            const saleSheet = await this.syncroniseState();
                                            const result = await this.saveSaleSheet(saleSheet);
                                
                                            if (result.result === false) {
                                                alert(result.error_message);
                                            }
                                            else {
                                                if (this.props.match.params.id === "new") {
                                                    this.setState({ sale_sheet_id: result.id },async ()=>{
                                                            //Create relation to property
                                                        
                                                            if (this.props.location.state.propertySaleSheets){
                                                                console.log("Saved sale sheet now looping through properties");
                                                                const propertySaleSheets = await this.createPropertyLinks();
                                                                if (propertySaleSheets){
                                                                    const result1 = await this.updateTableState(propertySaleSheets, "propertySaleSheets");
                                                                
                                                                    const saleSheetClassifications = await this.createCategoryLinks();
                                                                    if (saleSheetClassifications){
                                                                        const result2 = await this.updateTableState(saleSheetClassifications, "saleSheetClassifications");
                                                                
                                                                        if (result1 && result2){
                                                                            let idList =  [...this.state.idList];
                                                                            idList.push(this.state.sale_sheet_id);
                                                                            this.props.history.push(`/properties/${this.state.property_key}/salesheets/` + this.state.sale_sheet_id, {data: idList, propertyidlist: this.state.propertyidlist});
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        
                                                            });
                                                }
                                            }
                                        } finally {
                                            if (this.cloneSaveKey === cloneSaveKey) {
                                                pendingCloneSaleSheetSaves.delete(cloneSaveKey);
                                                this.cloneSaveKey = null;
                                            }
                                        }
                                    });
                        
                        
            
                    }
                }
                //New salesheet from property detail page or Add New from Salesheet
                else{
                    this.setState(state => ({ property_id: this.props.location.search.replace("?propertyid=", ""), 
                                            created_date: new Date, 
                                            created_by: this.props.user, 
                                            current: true ,             
                                            sale_follow_up_date : (new Date()).toLocaleDateString('en-AU',options)              
                                        }),
                    this.syncroniseState);
                }
                
                
                

                document.title = "New sale sheet for " + this.state.property_key;
            }
            else {
                await this.retrieveSaleSheet();
                const propertySaleSheetsFilter = { salesheetid: this.props.match.params.id };
                const saleSheetClassificationFilter = { salesheetid: this.state.sale_sheet_id };

                this.setState({
                    original_sale_follow_up_date: this.state.sale_status_date_checked,
                    propertySaleSheetsFilter,
                    saleSheetClassificationFilter,
                });

                // Load related datasets in parallel so the Properties card is ready sooner.
                try {
                    await Promise.all([
                        this.getPropertySaleSheets(propertySaleSheetsFilter),
                        this.getSaleSheetClassifications(saleSheetClassificationFilter),
                    ]);
                }
                catch{
                    alert("Error loading related sale sheet records");
                }
                document.title = this.state.property_key +" salesheet" ;
           
            }
            await this.getClassifications();
            
            this.setState(state => ({ selectedAgent1: { value: this.state.entity_id_sale_agent_1, label: this.state.sale_agent_1 } }));
            this.setState(state => ({ selectedAgent1Contact1: { value: this.state.entity_contact_id_1_sale_agent_1, label: this.state.contact_1_sale_agent_1 } }));
            this.setState(state => ({ selectedAgent1Contact2: { value: this.state.entity_contact_id_2_sale_agent_1, label: this.state.contact_2_sale_agent_1 } }));

            this.setState(state => ({ selectedAgent2: { value: this.state.entity_id_sale_agent_2, label: this.state.sale_agent_2 } }));
            this.setState(state => ({ selectedAgent2Contact1: { value: this.state.entity_contact_id_1_sale_agent_2, label: this.state.contact_1_sale_agent_2 } }));
            this.setState(state => ({ selectedAgent2Contact2: { value: this.state.entity_contact_id_2_sale_agent_2, label: this.state.contact_2_sale_agent_2 } }));


            //If there is an agent 1, pull back entities with matching name then the related entity will be selected
            
            if (this.state.entity_id_sale_agent_1) {
                console.log("Setting agent 1 options");
                const agent1Options = await this.getAgents({ entityid: this.state.entity_id_sale_agent_1 });
                this.setState(state => ({ agent1Options }));
                this.setState(state => ({ showAgent1DropDown: true }));
            }                  
            
            const agent1ContactOptions = await this.getAgentContacts({ entityid: this.state.entity_id_sale_agent_1 });
            this.setState(state => ({ agent1ContactOptions }));  

            if (this.state.selectedAgent1Contact1) {                
                this.setState(state => ({
                    showAgent1Contact1DropDown: true
                }));
            }
            if (this.state.selectedAgent1Contact2) {
                this.setState(state => ({
                    showAgent1Contact2DropDown: true
                }));
            }


            if (this.state.entity_id_sale_agent_2 ) {
                const agent2Options = await this.getAgents({ entityid: this.state.entity_id_sale_agent_2  });
                this.setState(state => ({ agent2Options }));
                this.setState(state => ({
                    showAgent2DropDown: true
                }));
                
            }

            const agent2ContactOptions = await this.getAgentContacts({ entityid: this.state.entity_id_sale_agent_2 });
            this.setState(state => ({ agent2ContactOptions }));

            if (this.state.selectedAgent2Contact1) {
                this.setState(state => ({
                    showAgent2Contact1DropDown: true
                }));
            }
            if (this.state.selectedAgent2Contact2) {
                this.setState(state => ({
                    showAgent2Contact2DropDown: true
                }));
            }


            this.setState({ selectedSaleStatus: { value: this.state.sale_status_code, label: this.state.sale_status } });
            await this.getSaleStatus();

            




            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }


    async syncroniseState() {
        const saleSheet = {
            sale_sheet_id: this.state.sale_sheet_id,
            current: this.state.current,
            sales_notes: this.state.sales_notes,
            sale_status_code: this.state.sale_status_code,
            sale_status: this.state.sale_status,
            sale_status_date_checked: this.state.sale_status_date_checked,
            sale_follow_up_date: this.state.sale_follow_up_date,
            entity_id_sale_agent_1: this.state.entity_id_sale_agent_1,
            sale_agent_1: this.state.sale_agent_1,
            entity_id_sale_agent_2: this.state.entity_id_sale_agent_2,
            sale_agent_2: this.state.sale_agent_2,
            sale_agent_1_phone: this.state.sale_agent_1_phone,
            sale_agent_2_phone: this.state.sale_agent_2_phone,
            sale_agent_1_contacts: this.state.sale_agent_1_contacts,
            sale_agent_2_contacts: this.state.sale_agent_2_contacts,
            current_questions: this.state.current_questions,
            quick_ref: this.state.quick_ref,
            entity_contact_id_1_sale_agent_1: this.state.entity_contact_id_1_sale_agent_1,
            contact_1_sale_agent_1: this.state.contact_1_sale_agent_1,
            contact_1_sale_agent_1_phone: this.state.contact_1_sale_agent_1_phone,
            contact_1_sale_agent_1_email: this.state.contact_1_sale_agent_1_email,
            entity_contact_id_2_sale_agent_1: this.state.entity_contact_id_2_sale_agent_1,
            contact_2_sale_agent_1: this.state.contact_2_sale_agent_1,
            contact_2_sale_agent_1_phone: this.state.contact_2_sale_agent_1_phone,
            contact_2_sale_agent_1_email: this.state.contact_2_sale_agent_1_email,
            entity_contact_id_1_sale_agent_2: this.state.entity_contact_id_1_sale_agent_2,
            contact_1_sale_agent_2: this.state.entity_contact_id_1_sale_agent_2,
            contact_1_sale_agent_2_phone: this.state.contact_1_sale_agent_2_phone,
            contact_1_sale_agent_2_email: this.state.contact_1_sale_agent_2_email,
            entity_contact_id_2_sale_agent_2: this.state.entity_contact_id_2_sale_agent_2,
            contact_2_sale_agent_2: this.state.contact_2_sale_agent_2,
            contact_2_sale_agent_2_phone: this.state.contact_2_sale_agent_2_phone,
            contact_2_sale_agent_2_email: this.state.contact_2_sale_agent_2_email,
            doc_date_ordered: this.state.doc_date_ordered,
            doc_date_rec: this.state.doc_date_rec,
            doc_notes: this.state.doc_notes,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by,
            archived_date: this.state.archived_date
        };

        this.setState({ saleSheet });
        return saleSheet;
    }
    

    async retrieveSaleSheet() {
        const saleSheet = await this.getSaleSheet();

        const {
            sale_sheet_id,
            current,
            sales_notes,
            sale_status_code,
            sale_status,
            sale_status_date_checked,
            sale_follow_up_date,
            entity_id_sale_agent_1,
            sale_agent_1,
            entity_id_sale_agent_2,
            sale_agent_2,
            sale_agent_1_phone,
            sale_agent_2_phone,
            sale_agent_1_contacts,
            sale_agent_2_contacts,
            current_questions,
            quick_ref,
            entity_contact_id_1_sale_agent_1,
            contact_1_sale_agent_1,
            contact_1_sale_agent_1_phone,
            contact_1_sale_agent_1_email,
            entity_contact_id_2_sale_agent_1,
            contact_2_sale_agent_1,
            contact_2_sale_agent_1_phone,
            contact_2_sale_agent_1_email,
            entity_contact_id_1_sale_agent_2,
            contact_1_sale_agent_2,
            contact_1_sale_agent_2_phone,
            contact_1_sale_agent_2_email,
            entity_contact_id_2_sale_agent_2,
            contact_2_sale_agent_2,
            contact_2_sale_agent_2_phone,
            contact_2_sale_agent_2_email,
            doc_date_ordered,
            doc_date_rec,
            doc_notes,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = saleSheet;

        this.setState({
            saleSheet,
            sale_sheet_id,
            current,
            sales_notes,
            sale_status_code,
            sale_status,
            sale_status_date_checked,
            sale_follow_up_date,
            entity_id_sale_agent_1,
            sale_agent_1,
            entity_id_sale_agent_2,
            sale_agent_2,
            sale_agent_1_phone,
            sale_agent_2_phone,
            sale_agent_1_contacts,
            sale_agent_2_contacts,
            current_questions,
            quick_ref,
            entity_contact_id_1_sale_agent_1,
            contact_1_sale_agent_1,
            contact_1_sale_agent_1_phone,
            contact_1_sale_agent_1_email,
            entity_contact_id_2_sale_agent_1,
            contact_2_sale_agent_1,
            contact_2_sale_agent_1_phone,
            contact_2_sale_agent_1_email,
            entity_contact_id_1_sale_agent_2,
            contact_1_sale_agent_2,
            contact_1_sale_agent_2_phone,
            contact_1_sale_agent_2_email,
            entity_contact_id_2_sale_agent_2,
            contact_2_sale_agent_2,
            contact_2_sale_agent_2_phone,
            contact_2_sale_agent_2_email,
            doc_date_ordered,
            doc_date_rec,
            doc_notes,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });
    }


    //Call API

    getSaleSheet() {
        try {
            const result = API.get("colin", `/salesheets/${this.props.match.params.id}`);
            return result
        }
        catch{
            console.log("Error getting the sale sheet");
        }

    }

    async saveSaleSheet(saleSheet) {
      
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.sale_sheet_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/salesheets/new`, { body: saleSheet });
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/salesheets/${this.state.sale_sheet_id}`, { body: saleSheet });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }

    

    getAgents(params) {
        try {
            return API.get("colin", `/entities/dropdown`, { 'queryStringParameters': params });
        }
        catch{
            console.log("Error getting agents");
        }
    }

    getAgentContacts(params) {
        try {
            return API.get("colin", `/entitycontacts/dropdown`, { 'queryStringParameters': params });
        }
        catch{
            console.log("Error getting agent contacts");
        }
    }

    async getPropertySaleSheets(params) {
        try {
            const propertySaleSheets = await API.get("colin", `/propertysalesheets`, { queryStringParameters: params });
            if (!Array.isArray(propertySaleSheets)) {
                return [];
            }

            const unsavedRows = (this.state.propertySaleSheets || []).filter((row) => {
                return Boolean(row?.new_record || !row?.property_sale_sheet_id);
            });

            const mergedPropertySaleSheets = [...propertySaleSheets, ...unsavedRows];

            mergedPropertySaleSheets.sort(function (a, b) {
                if(a.cityscope>b.cityscope){ 
                    return 1
                }else if((a.map_number)>(b.map_number)){ 
                    return 1
                }else if((a.map_number_suffix||"")>(b.map_number_suffix||"")){ 
                    return 1
                }else if(a.property_number>b.property_number){
                    return 1
                }else if((a.property_number_suffix||"")>(b.property_number_suffix||"")){
                    return 1
                }else if((a.unit_sort||0)>(b.unit_sort||0)) {
                    return 1
                } else {
                    return -1} });
            this.setState(state => ({ propertySaleSheets: mergedPropertySaleSheets }));
            if (propertySaleSheets.length===1){
                
                this.setState(state => ({ property_key : propertySaleSheets[0].property_key   }));
            }

            return mergedPropertySaleSheets;
        }
        catch{
            console.log("Error getting properties");
            return [];
        }
    }

    getSaleStatus() {
        try {
            API.get("colin", `/salestatus`).then((saleStatusOptions) => {
                if (saleStatusOptions) {
                    
                    this.setState(state => ({ saleStatusOptions }));
                }
            });
        }
        catch{
            console.log("Error getting sale status");
        }
    }

    async getSaleSheetClassifications(filter) {
        try {
            const saleSheetClassifications = await API.get(
                "colin",
                "/salesheets/" + this.state.sale_sheet_id + "/classifications",
                { queryStringParameters: filter }
            );
            if (Array.isArray(saleSheetClassifications)) {
                this.setState(state => ({ saleSheetClassifications }));
                return saleSheetClassifications;
            }
            return [];
        }
        catch{
            console.log("Error getting sale sheet classifications");
            return [];
        }
    }

    getClassifications() {
        try {
            API.get("colin", `/classifications`).then((classificationOptions) => {
                if (classificationOptions) {
                    this.setState(state => ({ classificationOptions }));
                }
            });
        }
        catch{
            console.log("Error getting classifications");
        }
    }
    

    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }

    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/properties/${this.state.property_key}/salesheets/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    async checkFollowUpdate(){
        if(this.state.original_sale_follow_up_date===this.state.sale_status_date_checked){
            const confirmed = window.confirm(
                "Did you want to update the last follow up date?"
            );

            if (confirmed) {
                this.setState({sale_status_date_checked: new Date(), modified: true, evermodified: false},this.handleBlur);
            }
            return
        }
        return
    }

    handleBackToProperty = async event =>{

        if(this.state.evermodified){
            await this.checkFollowUpdate()
            
        }
        this.props.history.push({pathname:`/properties/${this.state.property_key}`, state: {tab: "salesheets", data: this.state.propertyidlist}});
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }

    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh nabers");

        const nabers = await this.getNabers(this.state.naberFilter);
        this.setState({ nabers });
    }

    validateRelatedRecord(record, set) {
        //property
        if (set === "saleSheet") {

            // secondly check that UnitSort has been specified if required

            console.log("");


        }

        if (set === "propertySaleSheets") {

            // secondly check that UnitSort has been specified if required

            const propertyKey = typeof record.property_key === "string"
                ? record.property_key.trim()
                : record.property_key;

            if (!propertyKey) {
                return [false, "Enter a Cityscope reference."];
            }


        }

        return [true,];
    }
    

    async updateTableState(data, set) {
        this.setState({
            [set]: data
        });
        return true
    }

    saveRecord(record, endpoint, id) {

        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                if(endpoint=='saleSheetClassifications'){
                    return API.post("colin", `/salesheets/${this.state.sale_sheet_id}/classifications/new`, {
                        body: record
                    });
                }else{
                return API.post("colin", `/${endpoint.toLowerCase()}/new`, {
                    body: record
                });
            }
            }
        }
        //If not a new record and updating an existing, perform a put
        if(endpoint=='saleSheetClassifications'){
            return API.put("colin", `/salesheets/${this.state.sale_sheet_id}/classifications/${record[id]}`, {
                body: record
            });
        }else{
        return API.put("colin", `/${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        }
        );
    }
    }

    handleSaleStatusChange = (selectedSaleStatus) => {
        this.setState({ selectedSaleStatus 
                    ,sale_status_code: selectedSaleStatus.value    
                    ,sale_status: selectedSaleStatus.label   
                    ,modified: true },this.handleBlur);    
        
    }
    
    handleSuburbChange = (selectedSuburb) => {
        console.log(selectedSuburb);
        this.setState({ selectedSuburb
                        ,suburb: selectedSuburb.suburb 
                        ,state: selectedSuburb.state
                        ,postcode: selectedSuburb.postcode 
                        ,modified: true },this.handleBlur);
    }

    togglePropertySaleSheetModal = () => {
        this.setState({
            showPropertySaleSheetDialog: !this.state.showPropertySaleSheetDialog
        });
    }


    handleAgent1Search = async () => {
        try {
            const params = { name: this.state.agent1SearchString };
            if (this.state.agent1InterstateFlag === false && this.state.propertySaleSheets.length > 0) {
                console.log("Applying state filter");
                params.state = this.state.propertySaleSheets[0].state;
            }

            const agent1Options = await this.getAgents(params);
            
            this.setState({ agent1Options 
                            ,showAgent1DropDown: true
                            ,agent1MenuIsOpen: true });    
                  
        }
        catch{
            alert("Error loading agents");
        }
    }

    handleAgent2Search = async () => {
        try {
            const params = { name: this.state.agent2SearchString };
            if (this.state.agent2InterstateFlag === false && this.state.propertySaleSheets.length > 0) {
                params.state = this.state.propertySaleSheets[0].state;
            }

            const agent2Options = await this.getAgents(params);
            this.setState(state => ({ agent2Options
                        ,showAgent2DropDown: true
                        ,agent2MenuIsOpen: true }));

        }
        catch(e) {
            alert("Error loading agents " + e);
        }

    }

   

    handleAgent1Change = async (selectedAgent1) => {
        //agency 1 contact 1
        this.setState({ selectedAgent1Contact1: {value: null, label: null}
                         ,entity_contact_id_1_sale_agent_1: ""                         
                         ,contact_1_sale_agent_1: "" 
                         ,contact_1_sale_agent_1_phone:""
                         ,contact_1_sale_agent_1_email:""
                         , selectedAgent1Contact2: {value: null, label: null}
                         ,entity_contact_id_2_sale_agent_1: ""
                         ,contact_2_sale_agent_1: "" 
                         ,contact_2_sale_agent_1_phone:""
                         ,contact_2_sale_agent_1_email:""});


        this.setState({ selectedAgent1 });
        if (selectedAgent1) {
            this.setState({   entity_id_sale_agent_1: selectedAgent1.value
                            , sale_agent_1: selectedAgent1.label 
                            , sale_agent_1_phone: selectedAgent1.telephone
                            , sale_agent_1_contacts: ""
                            , modified: true },this.handleBlur);

            //Get contacts
            const agent1ContactOptions = await this.getAgentContacts({ entityid: selectedAgent1.value });
            this.setState(state => ({ agent1ContactOptions })); 

        }
        else {
            this.setState({ entity_id_sale_agent_1: null
                             ,sale_agent_1: null 
                             ,sale_agent_1_phone: ""
                            , sale_agent_1_contacts: ""
                            ,showAgent1DropDown: false
                            , modified: true },this.handleBlur);
        }
        this.setState({ agent1MenuIsOpen: false});

        
    }

    handleAgent2Change = async (selectedAgent2) => {        
        this.setState({ selectedAgent2Contact1: {value: null, label: null} 
                        ,entity_contact_id_1_sale_agent_2: "" 
                        ,contact_1_sale_agent_2: "" 
                        ,contact_1_sale_agent_2_phone:""
                        ,contact_1_sale_agent_2_email:""
                        ,selectedAgent2Contact2: {value: null, label: null} 
                        ,entity_contact_id_2_sale_agent_2: "" 
                        ,contact_2_sale_agent_2: ""                         
                        , modified: true
                        ,contact_2_sale_agent_2_phone:""
                        ,contact_2_sale_agent_2_email:""
                    },this.handleBlur);

        this.setState({ selectedAgent2 });

        if (selectedAgent2) {
            this.setState({ entity_id_sale_agent_2: selectedAgent2.value
                            , sale_agent_2: selectedAgent2.label 
                            , sale_agent_2_phone: selectedAgent2.telephone
                            , sale_agent_2_contacts: ""
                            ,showAgent2DropDown: true
                            , modified: true },this.handleBlur);

            //Get contacts
            const agent2ContactOptions = await this.getAgentContacts({ entityid: selectedAgent2.value });
            this.setState(state => ({ agent2ContactOptions }));

           
        }
        else {
            this.setState({ entity_id_sale_agent_2: null
                            , sale_agent_2: null 
                            , sale_agent_2_phone: ""
                            , sale_agent_2_contacts: ""
                            , showAgent2DropDown: false
                            , modified: true },this.handleBlur);
        }

        this.setState({ agent2MenuIsOpen: false});
        
        
    }

    closeAgent1 = async e =>{
        //if escaped close menu
        if (e.keyCode === 27) {
            this.setState({ agent1MenuIsOpen: false});
        }
    }

    closeAgent2 = async e =>{

        if (e.keyCode === 27) {
            this.setState({ agent2MenuIsOpen: false});
        }
    }


    handleAgent1Contact1Change = (selectedAgent1Contact1) => {
        this.setState({ selectedAgent1Contact1 });
        console.log(selectedAgent1Contact1);
        if(selectedAgent1Contact1){
            this.setState({  entity_contact_id_1_sale_agent_1: selectedAgent1Contact1.value 
                            ,contact_1_sale_agent_1: selectedAgent1Contact1.label 
                            ,contact_1_sale_agent_1_email: selectedAgent1Contact1.email
                            ,contact_1_sale_agent_1_phone: selectedAgent1Contact1.telephone
                            ,modified: true },this.handleBlur);
        }
        else{
            this.setState({ entity_contact_id_1_sale_agent_1: ""
                            ,contact_1_sale_agent_1: ""
                            ,contact_1_sale_agent_1_email: ""
                            ,contact_1_sale_agent_1_phone: ""
                            ,modified: true 
                        },this.handleBlur);
        }
      
    }

    handleAgent1Contact2Change = (selectedAgent1Contact2) => {
        this.setState({ selectedAgent1Contact2 });
        if(selectedAgent1Contact2){
            this.setState({ entity_contact_id_2_sale_agent_1: selectedAgent1Contact2.value
                            ,contact_2_sale_agent_1: selectedAgent1Contact2.label 
                            ,contact_2_sale_agent_1_email: selectedAgent1Contact2.email
                            ,contact_2_sale_agent_1_phone: selectedAgent1Contact2.telephone
                            ,modified: true                             
                        },this.handleBlur);
        }else{
            this.setState({ entity_contact_id_2_sale_agent_1: "" 
                            ,contact_2_sale_agent_1: ""
                            ,contact_2_sale_agent_1_email: ""
                            ,contact_2_sale_agent_1_phone: ""
                            ,modified: true 
                        },this.handleBlur);
        }
        
    }

    handleAgent2Contact1Change = (selectedAgent2Contact1) => {
        this.setState({ selectedAgent2Contact1 });
        if(selectedAgent2Contact1){
            this.setState({ entity_contact_id_1_sale_agent_2: selectedAgent2Contact1.value
                            ,contact_1_sale_agent_2: selectedAgent2Contact1.label 
                            ,contact_1_sale_agent_2_email: selectedAgent2Contact1.email
                            ,contact_1_sale_agent_2_phone: selectedAgent2Contact1.telephone
                            ,modified: true 
                        },this.handleBlur);
        }else{
            this.setState({ entity_contact_id_1_sale_agent_2: ""
                            , contact_1_sale_agent_2: "" 
                            ,contact_1_sale_agent_2_email: ""
                            ,contact_1_sale_agent_2_phone: ""
                            ,modified: true 
                            },this.handleBlur);
        }
        
    }

    handleAgent2Contact2Change = (selectedAgent2Contact2) => {
        this.setState({ selectedAgent2Contact2 });
        if(selectedAgent2Contact2){
            this.setState({ entity_contact_id_2_sale_agent_2: selectedAgent2Contact2.value
                            ,contact_2_sale_agent_2: selectedAgent2Contact2.label 
                            ,contact_2_sale_agent_2_email: selectedAgent2Contact2.email
                            ,contact_2_sale_agent_2_phone: selectedAgent2Contact2.telephone
                            ,modified: true 
                            });
        }else{
            this.setState({ entity_contact_id_2_sale_agent_2: ""
                            ,contact_2_sale_agent_2: ""
                            ,contact_2_sale_agent_2_email: ""
                            ,contact_2_sale_agent_2_phone: ""
                            ,modified: true 
                         });
        }
    }



    

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

 

    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }



    handleCheckBoxChange = event => {
        console.log(event)
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur);
        
    }

    
    async addPropertyRelation(saleSheetId) {
        let data = [...this.state.propertySaleSheets];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_id: this.state.property_id,
            property_key: this.state.property_key,
            sale_sheet_id: saleSheetId,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.updateTableState(data, "propertySaleSheets");
        const result = await this.saveRecord(data[0], "propertySaleSheets", "property_sale_sheet_id");
        if (result.result) {
            data[0].property_sale_sheet_id = result.id;
            data[0].new_record = false;
            this.updateTableState(data, "propertySaleSheets");
        }
        else {
            this.setState({ errorMessage: result.error_message });
            this.setState({ showAlert: true });
        }

        return;
    }


    handleBlur = async event => {
        console.log("In handleBlur");
        
        

        if (this.state.modified === true && this.state.savingNew === false) {
            this.setState({ showAlert: false, last_edited_by: this.props.user });
            const result = await this.syncroniseState();

            const validation = this.validateRelatedRecord(this.state.saleSheet, "saleSheet");
            console.log(validation)
            if (validation[0] === true) {
                try {
                    

                    this.setState(state => ({ modified: false, evermodified: true }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true, savingNew: true });
                    }
                    console.log("Saving sale");
                    const result = await this.saveSaleSheet(this.state.saleSheet);
                    
                    if (result.result === false) {
                        alert(result.error_message);
                    }
                    else {
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ sale_sheet_id: result.id }));
                            //Create relation to property
                            await this.addPropertyRelation(result.id);
                            this.props.history.push("/salesheets/" + result.id);
                        }
                    }
                    this.setState({ isLoading: false, savingNew: false });



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }

    

    handleClone = async event =>{
        event.preventDefault();

        let propertySaleSheetsForClone = Array.isArray(this.state.propertySaleSheets)
            ? [...this.state.propertySaleSheets]
            : [];
        let saleSheetClassificationsForClone = Array.isArray(this.state.saleSheetClassifications)
            ? [...this.state.saleSheetClassifications]
            : [];

        // If linked tables have not loaded yet, fetch them now so clone includes everything.
        if (this.state.sale_sheet_id && (propertySaleSheetsForClone.length === 0 || saleSheetClassificationsForClone.length === 0)) {
            try {
                const [fetchedPropertySaleSheets, fetchedSaleSheetClassifications] = await Promise.all([
                    propertySaleSheetsForClone.length === 0
                        ? API.get("colin", `/propertysalesheets`, {
                            queryStringParameters: { salesheetid: this.state.sale_sheet_id },
                        })
                        : Promise.resolve(propertySaleSheetsForClone),
                    saleSheetClassificationsForClone.length === 0
                        ? API.get("colin", `/salesheets/${this.state.sale_sheet_id}/classifications`, {
                            queryStringParameters: { salesheetid: this.state.sale_sheet_id },
                        })
                        : Promise.resolve(saleSheetClassificationsForClone),
                ]);

                if (Array.isArray(fetchedPropertySaleSheets)) {
                    propertySaleSheetsForClone = fetchedPropertySaleSheets;
                    this.setState({ propertySaleSheets: fetchedPropertySaleSheets });
                }

                if (Array.isArray(fetchedSaleSheetClassifications)) {
                    saleSheetClassificationsForClone = fetchedSaleSheetClassifications;
                    this.setState({ saleSheetClassifications: fetchedSaleSheetClassifications });
                }
            } catch (error) {
                alert("Unable to load linked records for clone. Please try again.");
                return;
            }
        }

        const clonePropertyId =
            this.state.property_id || propertySaleSheetsForClone?.[0]?.property_id || null;
        const clonePropertyKey =
            this.state.property_key || propertySaleSheetsForClone?.[0]?.property_key || null;

        this.props.history.push(
            `/properties/${clonePropertyKey || this.state.property_key}/salesheets/new?propertyid=${clonePropertyId || ""}`,
            {
                saleSheetClassifications: saleSheetClassificationsForClone,
                salesheet: this.state.saleSheet,
                propertySaleSheets: propertySaleSheetsForClone,
                property_id: clonePropertyId,
                property_key: clonePropertyKey,
                data: this.state.idList,
                propertyidlist: this.state.propertyidlist,
            }
        );
    }


    handleNewSaleSheet = async event =>{
        event.preventDefault();
        const confirmed = window.confirm(
            "Copy the Agency/Agent details from this salesheet?"
        );
        let saleSheet={};
        if (confirmed) {
            saleSheet = {
                current: true,
                sales_notes: null,
                sale_status_code: null,
                sale_status: null,
                sale_status_date_checked: null, 
                sale_follow_up_date: null,
                entity_id_sale_agent_1: this.state.entity_id_sale_agent_1,
                sale_agent_1: this.state.sale_agent_1,
                entity_id_sale_agent_2: this.state.entity_id_sale_agent_2, 
                sale_agent_2: this.state.sale_agent_2,
                sale_agent_1_phone: this.state.sale_agent_1_phone,
                sale_agent_2_phone: this.state.sale_agent_2_phone,
                sale_agent_1_contacts: this.state.sale_agent_1_contacts,
                sale_agent_2_contacts: this.state.sale_agent_2_contacts,
                current_questions: null,
                quick_ref: null,
                entity_contact_id_1_sale_agent_1: this.state.entity_contact_id_1_sale_agent_1,
                contact_1_sale_agent_1: this.state.contact_1_sale_agent_1,
                contact_1_sale_agent_1_phone: this.state.contact_1_sale_agent_1_phone,
                contact_1_sale_agent_1_email: this.state.contact_1_sale_agent_1_email,
                entity_contact_id_2_sale_agent_1: this.state.entity_contact_id_2_sale_agent_1,
                contact_2_sale_agent_1: this.state.contact_2_sale_agent_1,
                contact_2_sale_agent_1_phone: this.state.contact_2_sale_agent_1_phone,
                contact_2_sale_agent_1_email: this.state.contact_2_sale_agent_1_email,
                entity_contact_id_1_sale_agent_2: this.state.entity_contact_id_1_sale_agent_2,
                contact_1_sale_agent_2: this.state.contact_1_sale_agent_2,
                contact_1_sale_agent_2_phone: this.state.contact_1_sale_agent_2_phone,
                contact_1_sale_agent_2_email: this.state.contact_1_sale_agent_2_email,
                entity_contact_id_2_sale_agent_2: this.state.entity_contact_id_2_sale_agent_2,
                contact_2_sale_agent_2: this.state.contact_2_sale_agent_2,
                contact_2_sale_agent_2_phone: this.state.contact_2_sale_agent_2_phone,
                contact_2_sale_agent_2_email: this.state.contact_2_sale_agent_2_email,
                doc_date_ordered: null,
                doc_date_rec: null,
                doc_notes: null
                }
        }else{
            saleSheet = {
                current: true,
                sales_notes: null,
                sale_status_code: null,
                sale_status: null,
                sale_status_date_checked: null, 
                sale_follow_up_date: null,
                entity_id_sale_agent_1: null,
                sale_agent_1: null,
                entity_id_sale_agent_2: null, 
                sale_agent_2: null,
                sale_agent_1_phone: null,
                sale_agent_2_phone: null,
                sale_agent_1_contacts: null,
                sale_agent_2_contacts: null,
                current_questions: null,
                quick_ref: null,
                entity_contact_id_1_sale_agent_1: null,
                contact_1_sale_agent_1: null,
                contact_1_sale_agent_1_phone: null,
                contact_1_sale_agent_1_email: null,
                entity_contact_id_2_sale_agent_1: null,
                contact_2_sale_agent_1: null,
                contact_2_sale_agent_1_phone: null,
                contact_2_sale_agent_1_email: null,
                entity_contact_id_1_sale_agent_2: null,
                contact_1_sale_agent_2: null,
                contact_1_sale_agent_2_phone: null,
                contact_1_sale_agent_2_email: null,
                entity_contact_id_2_sale_agent_2: null,
                contact_2_sale_agent_2: null,
                contact_2_sale_agent_2_phone: null,
                contact_2_sale_agent_2_email: null,
                doc_date_ordered: null,
                doc_date_rec: null,
                doc_notes: null
                }
        }
        this.props.history.push(`/properties/${this.state.property_key}/salesheets/new?propertyid=${this.state.property_id}`,{saleSheetClassifications: this.state.saleSheetClassifications,salesheet: saleSheet, propertySaleSheets: this.state.propertySaleSheets, data: this.state.idList, propertyidlist: this.state.propertyidlist});
    }
    

   


    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {
            if (!this.state.registered) {
                const confirmed = window.confirm(
                    "Are you sure you want to delete this sale sheet?"
                );

                if (!confirmed) {
                    return;
                }
                else {
                    this.setState({ archived_date: new Date() }, () =>
                    this.syncroniseState().then(async () => {
                            const result = await this.saveSaleSheet(this.state.saleSheet);
                            if (result.result === false) {
                                alert(result.error_message);
                            }
                            else {

                                this.props.history.push("/properties");
                            }
                        }
                        )
                    );
                }
      
                }

            }
            else {
                window.alert("Record cannot be deleted");
            }
        }
    





    togglePropertySaleSheetModal = async() => {
        this.setState({
            showPropertySaleSheetDialog: !this.state.showPropertySaleSheetDialog
        });
        await this.getPropertySaleSheets(this.state.propertySaleSheetsFilter);
        let propertySaleSheets = [...this.state.propertySaleSheets];
        
        propertySaleSheets.sort(function (a, b) {
                                                            if(a.cityscope>b.cityscope){ 
                                                                return 1
                                                            }else if((a.map_number)>(b.map_number)){ 
                                                                return 1
                                                            }else if((a.map_number_suffix||"")>(b.map_number_suffix||"")){ 
                                                                return 1
                                                            }else if(a.property_number>b.property_number){
                                                                return 1
                                                            }else if((a.property_number_suffix||"")>(b.property_number_suffix||"")){
                                                                return 1
                                                            }else if((a.unit_sort||0)>(b.unit_sort||0)) {
                                                                return 1
                                                            } else {
                                                                return -1} });
        this.setState({propertySaleSheets});
    }

    toggleSaleSheetClassificationModal = () => {
        this.setState({
            showSaleSheetClassificationDialog: !this.state.showSaleSheetClassificationDialog
        });
    }

    

    render() {
        const customDropdown = {
            
            
            control: (provided, state) => {
   
              const backgroundColor = '#f5efb0';
              return { ...provided, backgroundColor };
            }
          }
        return (
            <div className="SaleSheet">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        cssOverride={{
                            display: "block",
                            margin: "0 auto",
                            borderColor: "red",
                        }}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
                    {this.state.showSaleSheetClassificationDialog &&
                    <SaleSheetClassificationModal
                    show={this.state.showSaleSheetClassificationDialog}
                    onClose={this.toggleSaleSheetClassificationModal}
                    filter={this.state.saleSheetClassificationFilter}
                    isAuthenticated={this.props.isAuthenticated}
                    toggleSaleSheetClassificationModal={this.toggleSaleSheetClassificationModal}
                    user={this.props.user}
                    data={this.state.saleSheetClassifications}
                    updateTableState={this.updateTableState}
                    saveRecord={this.saveRecord}
                    deleteRecord={this.deleteRecord}
                    classificationOptions={this.state.classificationOptions}
                    validateRelatedRecord={this.validateRelatedRecord}
                    salesheetid={this.state.sale_sheet_id}
                    />
                }
               
                {this.state.showPropertySaleSheetDialog &&
                    <PropertySaleSheetModal
                    show={this.state.showPropertySaleSheetDialog}
                    onClose={this.togglePropertySaleSheetModal}
                    filter={this.state.propertySaleSheetsFilter}
                    isAuthenticated={this.props.isAuthenticated}
                    togglePropertySaleSheetModal={this.togglePropertySaleSheetModal}
                    user={this.props.user}
                    data={this.state.propertySaleSheets}
                    updateTableState={this.updateTableState}
                    saveRecord={this.saveRecord}
                    deleteRecord={this.deleteRecord}
                    validateRelatedRecord={this.validateRelatedRecord}
                    salesheetid={this.state.sale_sheet_id}
                    />
                }
                {this.state.saleSheet && this.props.isAuthenticated && !this.state.isLoading &&


                    <div className="PropertyForm">
                   
                    <Form  >
                        <Row>
                        <Col lg={3}></Col>
                        <Col>
                                <Nav className="justify-content-center " >
                                {this.state.previousId !== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <Link
                                            to={`/properties/${this.state.property_key}/salesheets/${this.state.previousId}`}
                                            state={{ data: this.state.idList, propertyidlist: this.state.propertyidlist }}
                                        >
                                            <Button type="button" variant="info"  size="sm">Previous</Button>
                                        </Link>{" "}
                                    </Nav.Item>}
                                    {this.state.nextId !== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <Link
                                            to={`/properties/${this.state.property_key}/salesheets/${this.state.nextId}`}
                                            state={{ data: this.state.idList, propertyidlist: this.state.propertyidlist }}
                                        >
                                            <Button type="button" variant="info"  size="sm">Next</Button>
                                        </Link>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && this.state.idList.length>0 &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                                </Col>
                          
                            <Col >
                            <Nav className="justify-content-end" >
                                {this.state.property_key &&
                            <Nav.Item  >
                                        
                                        {/* <LinkContainer to={ {pathname: `/properties/${this.state.property_key}`, state: {tab: "salesheets", data: this.state.propertyidlist}}} > */}
                                            <Button type="button" variant="primary"  onClick={this.handleBackToProperty} size="sm">Back to Property {this.state.property_key}</Button>
                                            {/* </LinkContainer> */}
                                            {" "}
                                    </Nav.Item>
                                }
                                {this.state.sale_sheet_id &&
                                <Nav.Item  > 
                                <Button
                                    variant="primary"
                                    onClick={this.handleClone}
                                    size="sm"
                                    type="button"
                                >Clone</Button>{" "}
                                </Nav.Item>
                                }
                                {this.state.sale_sheet_id &&
                                <Nav.Item  > 
                                <Button
                                    variant="primary"
                                    onClick={this.handleNewSaleSheet}
                                    size="sm"
                                    type="button"
                                >New Sale Sheet</Button>{" "}
                                </Nav.Item>
                                }



                                    <Nav.Item  > 
                                <Button
                                    variant="danger"
                                    onClick={this.handleDelete}
                                    size="sm"
                                    type="button"
                                >Delete</Button>
                                </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                    <Row  id="detail">
                            <Col>
                            <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                                <Tabs defaultActiveKey={0} id="tabset">
                                <Tab eventKey={0} title={!this.state.current ? "Sale Sheet Detail *** INACTIVE ***":"Sale Sheet Detail"}>
                        <Card >
                              

                                
                                    <Card.Body>
                                        


                                    <Row>
                                    <Col sm={12} md={6} lg={3}>

                                        <Card >
                                            <Card.Header></Card.Header>
                                            <Card.Body>

                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Created</Form.Label>
                                                    <Col>                                                                
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                
                                                
                                                <Form.Group as={Row} controlId="current" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Current</Form.Label>
                                                    <Col >
                                                        <Form.Check
                                                            checked={this.state.current}
                                                            onChange={this.handleCheckBoxChange}
                                                            label=""
                                                            type="checkbox"
                                                            onBlur={this.handleBlur}
                                                            name="current"

                                                            
                                                        />
                                                        {!this.state.current && <b><font color="red">** INACTIVE**</font></b>}
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} controlId="sale_status_date_checked" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Last Followed Up</Form.Label>
                                                    <Col>
                                                        <DatePicker
                                                            selected={this.state.sale_status_date_checked? new Date(this.state.sale_status_date_checked): null }
                                                            onChange={e => this.handleDateChange(e, "sale_status_date_checked")}
                                                           onBlur={this.handleBlur}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            isClearable={true}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} controlId="sale_follow_up_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Next Follow Up</Form.Label>
                                                    <Col>
                                                        <DatePicker
                                                            selected={this.state.sale_follow_up_date? new Date(this.state.sale_follow_up_date): null }
                                                            onChange={e => this.handleDateChange(e, "sale_follow_up_date")}
                                                           onBlur={this.handleBlur}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            isClearable={true}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                            </Card.Body>
                                        </Card>



                                        <Card >
                                            <Card.Header>Sale Details</Card.Header>
                                            <Card.Body>
                                                <Form.Group as={Row} controlId="selectedSaleStatus" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Marketing Status</Form.Label>
                                                    <Col>
                                                        
                                                        <Select
                                                            value={this.state.selectedSaleStatus}
                                                            onChange={this.handleSaleStatusChange}
                                                            options={this.state.saleStatusOptions}
                                                            onInputChange={this.handleInputChange}
                                                            onBlur={this.handleBlur}
                                                        />
                                                        
                                                    </Col>
                                                </Form.Group>

                                            </Card.Body>
                                        </Card>
                                        <Card>
                                            <Card.Header>Properties</Card.Header>
                                            <Card.Body>
        <Button onClick={this.togglePropertySaleSheetModal} size="sm" variant="secondary">Edit</Button>
        <PropertySaleSheetList                                                            
            isAuthenticated={this.props.isAuthenticated}
            controlType="list"
            data={this.state.propertySaleSheets}
            updateTableState={this.updateTableState}
            saveRecord={this.saveRecord}
            deleteRecord={this.deleteRecord}
            propertyid={this.state.property_id}
            propertykey={this.state.property_key}
            proposalid={this.state.sale_sheet_id}
        />
    </Card.Body>

</Card>
<Card >

                                                                                <Card.Header >4S Page Alternate Classification</Card.Header>
                                                                                <Card.Body>
                                                                                    <Button onClick={this.toggleSaleSheetClassificationModal} size="sm" variant="secondary" type="button">Edit</Button>
                                                                                    <SaleSheetClassificationList
                                                                                        filter={this.state.saleSheetClassificationFilter}
                                                                                        isAuthenticated={this.props.isAuthenticated}
                                                                                        controlType="list"
                                                                                        data={this.state.saleSheetClassifications}
                                                                                        updateTableState={this.updateTableState}
                                                                                        saveRecord={this.saveRecord}
                                                                                        deleteRecord={this.deleteRecord}
                                                                                    />
                                                                                </Card.Body>
                                                                            </Card >

</Col>

                                    <Col sm={12} md={6} lg={3}>

                                    <Card >

                                        <Card.Body>
                                            <Form.Group as={Row} controlId="quick_ref" >
                                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>Quick Reference</Form.Label>
                                                <Col>
                                                        <Form.Control
                                                            onChange={this.handleChange}
                                                            value={this.state.quick_ref ?? ""}
                                                            as="input"
                                                            type="text"
                                                        onBlur={this.handleBlur}
                                                        />                                                                
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="current_questions" >
                                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>Questions to ask Agent</Form.Label>
                                                <Col>
                                                        <Form.Control
                                                            onChange={this.handleChange}
                                                        value={this.state.current_questions ?? ""}
                                                        as="textarea"
                                                        rows="4"
                                                        type="text"
                                                        onBlur={this.handleBlur}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="sales_notes" >
                                                <Form.Label className="text-right"  sm={6} md={6} lg={3}>Sales Notes</Form.Label>
                                                
                                                        <Form.Control
                                                            onChange={this.handleChange}
                                                        value={this.state.sales_notes ?? ""}
                                                        as="textarea"
                                                        rows="16"
                                                        type="text"
                                                        onBlur={this.handleBlur}
                                                    />
                                                
                                            </Form.Group>
                                        </Card.Body>
                                    </Card>

                                    <Card >
                                        <Card.Header>Prospectus/Brochure Ordering</Card.Header>
                                        <Card.Body>

                                            <Form.Group as={Row} controlId="doc_date_ordered" >
                                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Ordered</Form.Label>
                                                <Col>
                                                    <DatePicker
                                                        selected={this.state.doc_date_ordered? new Date(this.state.doc_date_ordered): null}
                                                        onChange={e => this.handleDateChange(e, "doc_date_ordered")}
                                                        onBlur={this.handleBlur}
                                                        dateFormat="dd/MM/yyyy"
                                                        className="form-control"
                                                        isClearable={true}
                                                    />
                                                </Col>
                                            </Form.Group>
                                                <Form.Group as={Row} controlId="doc_date_rec" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Received</Form.Label>
                                                <Col>
                                                            <DatePicker
                                                                selected={this.state.doc_date_rec? new Date(this.state.doc_date_rec): null}
                                                                onChange={e => this.handleDateChange(e, "doc_date_rec")}
                                                                onBlur={this.handleBlur}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="form-control"
                                                                isClearable={true}
                                                            />
                                                        </Col>
                                            </Form.Group>
                                                    <Form.Group as={Row} controlId="doc_notes" >
                                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Doc Notes</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                onChange={this.handleChange}
                                                                value={this.state.doc_notes ?? ""}
                                                                as="input"
                                                                type="text"
                                                        onBlur={this.handleBlur}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                        </Card.Body>
                                    </Card>
                                    </Col>

                                            <Col sm={12} md={6} lg={3}>

                                                <Card >
                                                    <Card.Header>Agent 1</Card.Header>
                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="agent1SearchString" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Agency Search</Form.Label>
                                                            <Col>
                                                                <InputGroup size="sm" >
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.agent1SearchString ?? ""}
                                                                        as="input"
                                                                        type="text"
                                                                        onBlur={this.handleBlur}
                                                                        
                                                                    />
                                                                    <Button onClick={this.handleAgent1Search} variant="outline-secondary" size="sm">Search</Button>
                                                                </InputGroup>
                                                                </Col>
                                                        </Form.Group>
                                                                <Form.Group as={Row} controlId="Interstate" >
                                                                    <Col sm={6} md={6} lg={4}></Col>
                                                                    <Col>
                                                                        <Form.Check
                                                                            checked={this.state.agent1InterstateFlag}
                                                                            onChange={this.handleCheckBoxChange}
                                                                            label="Search interstate"
                                                                            type="checkbox"
                                                                            name="agent1InterstateFlag"
                                                                            onBlur={this.handleBlur}
                                                                            
                                                                        />

                                                                    </Col>
                                                                
                                                                </Form.Group>
                                                                {this.state.showAgent1DropDown &&
                                                                <Form.Group as={Row} controlId="showAgent1DropDown" >
                                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Agent 1</b></Form.Label>
                                                                    <Col>
                                                                    <Select
                                                                        value={this.state.selectedAgent1}
                                                                        onChange={this.handleAgent1Change}
                                                                        options={this.state.agent1Options}
                                                                        onInputChange={this.handleInputChange}
                                                                        onBlur={this.handleBlur}
                                                                        menuIsOpen={this.state.agent1MenuIsOpen}
                                                                        isClearable
                                                                        id="agent1"
                                                                        onKeyDown={this.closeAgent1}
                                                                        styles={customDropdown}
                                                                    />


                                                                    </Col>
                                                                </Form.Group>
                                                                }


                                                            
                                                        <Row>
                                                            <Col sm={6} md={6} lg={4}></Col>
                                                            <Col>

                                                                <Link to={`/entities/new?salesheetid=${this.state.sale_sheet_id}`}><Button variant="info" size="sm" type="button">Add New Agent</Button></Link>{" "}
                                                            {this.state.entity_id_sale_agent_1 && <Link to={`/entities/${this.state.entity_id_sale_agent_1}?salesheetid=${this.state.sale_sheet_id}`}><Button variant="info" type="button" size="sm">Edit Existing Agent</Button></Link> }
                                                            </Col>
                                                        </Row>
                                                        <Form.Group as={Row} controlId="sale_agent_1_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                    value={this.state.sale_agent_1_phone ?? ""}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                             
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="sale_agent_1_contacts" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Old Contacts</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.sale_agent_1_contacts ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <hr/>
                                                        <Form.Group as={Row} controlId="entity_contact_id_1_sale_agent_1" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Contact 1</b></Form.Label>
                                                            <Col>
                                                                {this.state.showAgent1Contact1DropDown &&
                                                                    
                                                                    <Select
                                                                        value={this.state.selectedAgent1Contact1}
                                                                        onChange={this.handleAgent1Contact1Change}
                                                                        options={this.state.agent1ContactOptions}                                                             
                                                                        onBlur={this.handleBlur}
                                                                        isClearable
                                                                        styles={customDropdown}
                                                                    />

                                                                }
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_1_sale_agent_1_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                    <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_1_sale_agent_1_phone ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_1_sale_agent_1_email" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                            <Col>
                                                                <InputGroup>
                                                                    <InputGroup.Text>@</InputGroup.Text>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_1_sale_agent_1_email ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    </InputGroup>

                                                            </Col>
                                                        </Form.Group>
                                                        <hr/>
                                                        <Form.Group as={Row} controlId="entity_contact_id_2_sale_agent_1" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Contact 2</b></Form.Label>
                                                            <Col>
                                                                {this.state.showAgent1Contact2DropDown &&
                                                                    <Select
                                                                        value={this.state.selectedAgent1Contact2}
                                                                    onChange={this.handleAgent1Contact2Change}
                                                                        options={this.state.agent1ContactOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    styles={customDropdown}
                                                                    />
                                                                }
                                                            </Col>
                                                        </Form.Group>
                                                        
                                                        <Form.Group as={Row} controlId="contact_2_sale_agent_1_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_2_sale_agent_1_phone ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_2_sale_agent_1_email" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                            <Col>
                                                                <InputGroup>
                                                                    <InputGroup.Text>@</InputGroup.Text>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_2_sale_agent_1_email ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    </InputGroup>

                                                            </Col>
                                                        </Form.Group>

                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col sm={12} md={6} lg={3}>

                                                <Card >
                                                    <Card.Header>Agent 2</Card.Header>
                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="agent2SearchString" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Agency Search</Form.Label>
                                                            <Col>
                                                                <InputGroup size="sm" >
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.agent2SearchString ?? ""}
                                                                        as="input"
                                                                        type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    <Button onClick={this.handleAgent2Search} variant="outline-secondary" size="sm">Search</Button>
                                                                </InputGroup>
                                                                </Col>
                                                                </Form.Group>
                                                                <Form.Group as={Row} controlId="Interstate" >
                                                                                    <Col sm={6} md={6} lg={4}></Col>
                                                                                    <Col>
                                                                                        <Form.Check
                                                                                            checked={this.state.agent2InterstateFlag}
                                                                                            onChange={this.handleCheckBoxChange}
                                                                                            label="Search interstate"
                                                                                            type="checkbox"
                                                                                            name="agent2InterstateFlag"
                                                                                            onBlur={this.handleBlur}
                                                                                            onKeyDown={this.closeAgent2}
                                                                                        />

                                                                                    </Col>

                                                                                </Form.Group>
                                                                {this.state.showAgent2DropDown &&
                                                                 <Form.Group as={Row} controlId="selectedAgent2" >
                                                                     <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Agent 2</b></Form.Label>
                                                                     <Col>
                                                                    <Select
                                                                        value={this.state.selectedAgent2}
                                                                        onChange={this.handleAgent2Change}
                                                                        options={this.state.agent2Options}
                                                                        onInputChange={this.handleInputChange}
                                                                        onBlur={this.handleBlur}
                                                                        isClearable
                                                                        menuIsOpen={this.state.agent2MenuIsOpen}
                                                                        escapeClearsValue="true"
                                                                        styles={customDropdown}
                                                                    />
                                                                    </Col>
                                                                        </Form.Group>
                                                                }


                                                            
                                                        <Row>
                                                            <Col sm={6} md={6} lg={4}></Col>
                                                            <Col>

                                                            <Link to={`/entities/new?salesheetid=${this.state.sale_sheet_id}`}><Button variant="info" type="button" size="sm">Add New Agent</Button></Link>{" "}
                                                            {this.state.entity_id_sale_agent_2 && <Link to={`/entities/${this.state.entity_id_sale_agent_2}?salesheetid=${this.state.sale_sheet_id}`}><Button size="sm" variant="info" type="button">Edit Existing Agent</Button></Link> }
                                                            </Col>
                                                        </Row>
                                                        <Form.Group as={Row} controlId="sale_agent_2_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.sale_agent_2_phone ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="sale_agent_2_contacts" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Old Contacts</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.sale_agent_2_contacts ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <hr />
                                                        <Form.Group as={Row} controlId="entity_contact_id_1_sale_agent_2" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Contact 1</b></Form.Label>
                                                            <Col>
                                                                {this.state.showAgent2Contact1DropDown &&
                                                                    <Select
                                                                        value={this.state.selectedAgent2Contact1}
                                                                    onChange={this.handleAgent2Contact1Change}
                                                                        options={this.state.agent2ContactOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    styles={customDropdown}
                                                                    />
                                                                }
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_1_sale_agent_2_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_1_sale_agent_2_phone ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_1_sale_agent_2_email" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                            <Col>
                                                                <InputGroup>
                                                                    <InputGroup.Text>@</InputGroup.Text>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_1_sale_agent_2_email ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    </InputGroup>

                                                            </Col>
                                                        </Form.Group>
                                                        <hr />
                                                        <Form.Group as={Row} controlId="entity_contact_id_2_sale_agent_2" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}><b>Contact 2</b></Form.Label>
                                                            <Col>
                                                                {this.state.showAgent2Contact2DropDown &&
                                                                    <Select
                                                                        value={this.state.selectedAgent2Contact2}
                                                                    onChange={this.handleAgent2Contact2Change}
                                                                        options={this.state.agent2ContactOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    styles={customDropdown}
                                                                    />
                                                                }
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_2_sale_agent_2_phone" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Phone</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_2_sale_agent_2_phone ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_2_sale_agent_2_email" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                            <Col>
                                                                <InputGroup>
                                                                    <InputGroup.Text>@</InputGroup.Text>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_2_sale_agent_2_email ?? ""}
                                                                    as="input"
                                                                    type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    </InputGroup>

                                                            </Col>
                                                        </Form.Group>

                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            
                                           

                                    </Row>






                                </Card.Body>
                            
                        </Card >
                      </Tab>
                    
                        
                                    
                              <Tab eventKey={1} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                    <Card.Body>
                                    <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by ?? ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by ?? ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                    </Card.Body>
                                </Card>

                            </Tab>

                        
                    </Tabs>

                        </Col>

                    </Row>
                   

                        
                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}

export default function SaleSheetDetail(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const history = {
        push: (to, state) => {
            if (typeof to === "string") {
                navigate(to, { state });
                return;
            }

            if (to && typeof to === "object") {
                navigate(to.pathname || "", {
                    search: to.search,
                    hash: to.hash,
                    state: to.state ?? state,
                    replace: Boolean(to.replace),
                });
            }
        },
    };

    return (
        <SaleSheetDetailClass
            {...props}
            match={{ params }}
            location={location}
            history={history}
        />
    );
}
